export const educationData = [
  {
    id: 1,
    institution: "Renaissance University, Indore",
    course: "Bachelor of Computer Application, Computer Science",
    startYear: "2021",
    endYear: "2024",
  },
  {
    id: 2,
    institution: "Aadharsh Boudhhik H. School",
    course: "Commerce + IP",
    startYear: "2020",
    endYear: "2021",
  },

  {
    id: 3,
    institution: "Vimal Vidhya Niketan H. S. School",
    course: "Higher Secondary Education",
    startYear: "2018",
    endYear: "2019",
  },
];
